// API base URLs whose latest request got no response at all. A host leaves the set on its next
// response of any status, or on the browser's `online` event (wired in main.tsx).
const unreachableHosts = new Set<string>();

export const isHostUnreachable = (host: string): boolean => unreachableHosts.has(host);

export const markHostUnreachable = (host: string): void => {
  unreachableHosts.add(host);
};

export const markHostReachable = (host: string): void => {
  unreachableHosts.delete(host);
};

export const clearUnreachableHosts = (): void => {
  unreachableHosts.clear();
};
